import { render, staticRenderFns } from "./producto.buscador.catalogo.vue?vue&type=template&id=c76b8738&scoped=true&"
import script from "./producto.buscador.catalogo.vue?vue&type=script&lang=js&"
export * from "./producto.buscador.catalogo.vue?vue&type=script&lang=js&"
import style0 from "./producto.buscador.catalogo.vue?vue&type=style&index=0&id=c76b8738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76b8738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
